import request from '@/utils/request';

//范围
export function optSearch(shareEid, data) {
    return request({
        url: `/share/${shareEid}/mavin/opt`,
        method: 'get',
        params: data
    });
}

export function optSave(shareEid, data) {
    return request({
        url: `/share/${shareEid}/mavin/opt`,
        method: 'post',
        data: data
    });
}

export function seledList(shareEid, data) {
    return request({
        url: `/share/${shareEid}/mavin/seled`,
        method: 'get',
        params: data
    });
}

export function seledDelete(shareEid, mavinEId) {
    return request({
        url: `/share/${shareEid}/mavin/seled/${mavinEId}`,
        method: 'delete'
    });
}